import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import { processingValidateUserRegistration, finishedValidateUserRegistration } from './kycActions';
export var validateUserRegistrationJumio = function validateUserRegistrationJumio(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var response, result, parsedResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(processingValidateUserRegistration);
              _context.next = 3;
              return dispatch(callAPI('ValidateUserRegistration', payload));
            case 3:
              response = _context.sent;
              result = void 0;
              try {
                parsedResult = JSON.parse(response.result);
                result = parsedResult.ValidationAnswerData;
              } catch (error) {
                result = response.result;
              }
              dispatch(finishedValidateUserRegistration);
              return _context.abrupt('return', result);
            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};